import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-modal-change-password',
  templateUrl: './modal-change-password.component.html',
  styleUrls: ['./modal-change-password.component.scss'],
})
export class ModalChangePasswordComponent implements OnInit {

  form: FormGroup;
  public hide1 = true;
  public hide2 = true;

  constructor(private modalCrtl: ModalController, private fb: FormBuilder, private loadingCtrl: LoadingController, private accountService: AccountService,
              private toastCtrl: ToastController, private navCtrl: NavController, private alertController: AlertController) { 
    this.form = this.fb.group({
      password: ['', Validators.compose([
        Validators.minLength(8),
        Validators.maxLength(20),
        Validators.required
      ])],
      newPassword: ['', Validators.compose([
        Validators.minLength(8),
        Validators.maxLength(20),
        Validators.required
      ])]
    });
  }

  ngOnInit() {}

  async confirmUpdate(){
    const alert = await this.alertController.create({
      header: 'Atualizar Senha',
      message: `Deseja atualizar sua senha?`,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Atualizar',
          handler: () => {
            this.update();
          }
        }
      ]
    });
    await alert.present();
  }

  async update(){
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.accountService.changePassword(this.form.value).subscribe(result => {
      if(result.success) {
        loading.dismiss();
        this.close();
        this.logout();
        this.showMessage(result.message);
      } else {
        loading.dismiss();
        this.showMessage(result.message);
      }
    }, error => {
      loading.dismiss();
      this.showMessage(error.message);
    });
  }

  close() {
    this.modalCrtl.dismiss();
  }

  logout(){
    Security.clear();
    this.goToPage('/intro');
  }

  goToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  toggleHide1() {
    this.hide1 = !this.hide1;
  }

  toggleHide2() {
    this.hide2 = !this.hide2;
  }

}
